import React, { useState } from 'react';
import { useStringsContext } from '../../../contexts/strings';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { SxStyle } from '../../../types';
import { MappingSelectType } from './mappings-list';

const styles: SxStyle = {
  formControl: {
    width: '200px',
  },
};

interface Props {
  onSelectedType: (selected: MappingSelectType) => void;
}

const MappingSelect = ({ onSelectedType }: Props) => {
  const { strings } = useStringsContext();
  const [selectedType, setSelectedType] = useState<MappingSelectType>('teams');

  const onChange = (event: SelectChangeEvent) => {
    const newSelectedType = event.target.value as MappingSelectType;
    setSelectedType(newSelectedType);
    onSelectedType(newSelectedType);
  };

  return (
    <FormControl sx={styles.formControl}>
      <InputLabel>{strings.mappings.selectType}</InputLabel>
      <Select size="small" value={selectedType} label="teams" onChange={onChange}>
        {(['teams', 'leagues'] as MappingSelectType[]).map((value) => (
          <MenuItem key={value} value={value}>
            {value}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default MappingSelect;
